import SearchButton from "./SearchButton";
import SearchPanel from "./SearchPanel";

export default {
    button: SearchButton,
    panel: SearchPanel,
    name: "search",
};
